// 📁 productService.js - Version complète avec gestion des images

import { apiCall } from './api';
import * as XLSX from 'xlsx';

/**
 * ✅ Fonction utilitaire pour corriger les URLs d'images
 */
// const fixImageUrl = (imageUrl) => {
//   if (!imageUrl) return null;
  
  
//   // Si l'URL commence par /api/uploads/, ajouter le serveur backend
//   if (imageUrl.startsWith('/api/uploads/')) {
//     const correctedUrl = `http://localhost:8080${imageUrl}`;
//     return correctedUrl;
//   }
  
//   // Si l'URL pointe vers le serveur React par erreur, corriger
//   if (imageUrl.includes('localhost:3000/api/uploads/')) {
//     const correctedUrl = imageUrl.replace('localhost:3000/', 'localhost:8080/');
//     return correctedUrl;
//   }
  
//   // Si c'est déjà une URL complète vers le bon serveur
//   if (imageUrl.startsWith('http://localhost:8080/api/uploads/')) {
//     return imageUrl;
//   }
  
//   // Si c'est juste un nom de fichier ou chemin relatif
//   if (!imageUrl.startsWith('http')) {
//     const correctedUrl = `http://localhost:8080/api/uploads/${imageUrl}`;
//     return correctedUrl;
//   }
  
//   return imageUrl;
// };

// ✅ NOUVEAU : Constants pour les types de produits
export const PRODUCT_TYPES = {
  STOCKABLE: 'STOCKABLE',
  SERVICE: 'SERVICE'
};

/**
 * ✅ EXPORT DES PRODUITS - Fonction principale
 * @param {Array} products - Liste des produits à exporter
 * @param {String} format - Format d'export ('excel' ou 'csv')
 * @param {Object} filters - Filtres appliqués (optionnel)
 */
const exportProducts = (products, format = 'excel', filters = {}) => {
  try {
    
    if (!products || products.length === 0) {
      return {
        success: false,
        message: 'Aucun produit à exporter'
      };
    }

    // Préparer les données pour l'export
    const exportData = products.map(product => ({
      'Nom': product.name || '',
      'Prix de vente (FCFA)': product.price || 0,
      'Prix de revient (FCFA)': product.costPrice || 0,
      'Marge (FCFA)': product.margin || 0,
      'Marge (%)': product.marginPercentage ? `${product.marginPercentage}%` : '0%',
      'Catégorie': product.categoryName || '',
      'Type': product.productType || 'STOCKABLE',
      'SKU': product.sku || '',
      'Code-barres': product.barcode || '',
      'Stock actuel': product.currentStock !== undefined ? product.currentStock : '-',
      'Seuil minimum': product.minThreshold || '-',
      'Seuil maximum': product.maxThreshold || '-',
      'Statut': product.isActive ? 'Actif' : 'Inactif',
      'Disponible': product.isAvailable ? 'Oui' : 'Non',
      'Stock bas': product.isLowStock ? 'Oui' : 'Non',
      'Description': product.description || '',
      'Date création': product.createdAt ? new Date(product.createdAt).toLocaleDateString('fr-FR') : '',
      'Dernière MAJ': product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : ''
    }));

    if (format === 'csv') {
      return exportToCSV(exportData, filters);
    } else {
      return exportToExcel(exportData, filters);
    }

  } catch (error) {
    console.error('❌ Erreur lors de l\'export:', error);
    return {
      success: false,
      message: 'Erreur lors de l\'export des produits'
    };
  }
};

/**
 * ✅ Export en CSV
 */
const exportToCSV = (data, filters) => {
  try {
    // Créer les en-têtes
    const headers = Object.keys(data[0]).join(',');
    
    // Créer les lignes
    const rows = data.map(row => 
      Object.values(row).map(value => {
        // Échapper les virgules et guillemets
        const stringValue = String(value);
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      }).join(',')
    );

    // Assembler le contenu
    const csvContent = [headers, ...rows].join('\n');

    // Créer le BOM UTF-8 pour Excel
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    
    // Générer le nom du fichier
    const filename = generateExportFilename('csv', filters);
    
    // Télécharger
    downloadFile(blob, filename);

    return {
      success: true,
      message: `${data.length} produits exportés en CSV`
    };

  } catch (error) {
    console.error('❌ Erreur export CSV:', error);
    return {
      success: false,
      message: 'Erreur lors de l\'export CSV'
    };
  }
};

/**
 * ✅ Export en Excel
 */
const exportToExcel = (data, filters) => {
  try {
    // Créer le workbook
    const wb = XLSX.utils.book_new();
    
    // Créer la feuille avec les données
    const ws = XLSX.utils.json_to_sheet(data);

    // Définir la largeur des colonnes
    const columnWidths = [
      { wch: 30 },  // Nom
      { wch: 15 },  // Prix de vente
      { wch: 15 },  // Prix de revient
      { wch: 12 },  // Marge
      { wch: 10 },  // Marge %
      { wch: 15 },  // Catégorie
      { wch: 12 },  // Type
      { wch: 15 },  // SKU
      { wch: 15 },  // Code-barres
      { wch: 12 },  // Stock
      { wch: 12 },  // Seuil min
      { wch: 12 },  // Seuil max
      { wch: 10 },  // Statut
      { wch: 10 },  // Disponible
      { wch: 10 },  // Stock bas
      { wch: 40 },  // Description
      { wch: 12 },  // Date création
      { wch: 12 }   // Dernière MAJ
    ];
    ws['!cols'] = columnWidths;

    // Ajouter la feuille au workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Produits');

    // Ajouter une feuille de résumé
    const summaryData = [
      { 'Paramètre': 'Total produits', 'Valeur': data.length },
      { 'Paramètre': 'Date export', 'Valeur': new Date().toLocaleString('fr-FR') }
    ];

    if (filters.category) {
      summaryData.push({ 'Paramètre': 'Catégorie filtrée', 'Valeur': filters.category });
    }
    if (filters.type) {
      summaryData.push({ 'Paramètre': 'Type filtré', 'Valeur': filters.type });
    }
    if (filters.availability !== undefined) {
      summaryData.push({ 'Paramètre': 'Disponibilité', 'Valeur': filters.availability });
    }
    if (filters.search) {
      summaryData.push({ 'Paramètre': 'Recherche', 'Valeur': filters.search });
    }

    const wsSummary = XLSX.utils.json_to_sheet(summaryData);
    wsSummary['!cols'] = [{ wch: 25 }, { wch: 30 }];
    XLSX.utils.book_append_sheet(wb, wsSummary, 'Résumé');

    // Générer le fichier
    const filename = generateExportFilename('xlsx', filters);
    XLSX.writeFile(wb, filename);

    return {
      success: true,
      message: `${data.length} produits exportés en Excel`
    };

  } catch (error) {
    console.error('❌ Erreur export Excel:', error);
    return {
      success: false,
      message: 'Erreur lors de l\'export Excel'
    };
  }
};

/**
 * ✅ Générer le nom du fichier d'export
 */
const generateExportFilename = (extension, filters) => {
  const date = new Date().toISOString().split('T')[0];
  const time = new Date().toTimeString().split(' ')[0].replace(/:/g, '-');
  let filename = `produits_${date}_${time}`;

  if (filters.category) {
    filename += `_${filters.category.replace(/\s+/g, '_')}`;
  }
  if (filters.type) {
    filename += `_${filters.type}`;
  }

  return `${filename}.${extension}`;
};

/**
 * ✅ Télécharger un fichier
 */
const downloadFile = (blob, filename) => {
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  
  // Nettoyer
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
};


const fixImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  
  
  // Si l'URL commence par /api/uploads/, ajouter le serveur backend avec smartboutik
  if (imageUrl.startsWith('/api/uploads/')) {
    const correctedUrl = `https://apps.prod.atlanticds-sn.com/smartboutik${imageUrl}`;
    return correctedUrl;
  }
  
  // Si l'URL pointe vers le serveur React par erreur, corriger vers le bon port
  if (imageUrl.includes('localhost:3000/api/uploads/')) {
    const correctedUrl = imageUrl.replace('localhost:3000/', 'localhost:8082/');
    return correctedUrl;
  }
  
  // Si c'est déjà une URL complète vers le bon serveur (port 8082)
  if (imageUrl.startsWith('http://localhost:8082/api/uploads/')) {
    return imageUrl;
  }
  
  // Si c'est déjà une URL complète vers la production
  if (imageUrl.startsWith('https://apps.prod.atlanticds-sn.com/smartboutik/api/uploads/')) {
    return imageUrl;
  }
  
  // Si c'est juste un nom de fichier ou chemin relatif
  if (!imageUrl.startsWith('http')) {
    const correctedUrl = `https://apps.prod.atlanticds-sn.com/smartboutik/api/uploads/${imageUrl}`;
    return correctedUrl;
  }
  
  return imageUrl;
};
/**
 * ✅ Formatage des produits pour l'affichage avec images ET PROMOTIONS
 */
const formatProduct = (product) => {
  if (!product) return null;
  
  // ✅ NOUVEAU : Récupérer les infos de promotion
  const hasPromo = product.has_promo || product.hasPromo || false;
  const promoPrice = product.promo_price || product.promoPrice || null;
  const discountPercentage = product.discount_percentage || product.discountPercentage || null;
  
  const formatted = {
    id: product.id,
    name: product.name,
    productType: product.product_type || product.productType || 'STOCKABLE',
    description: product.description,
    sku: product.sku,
    barcode: product.barcode,
    price: product.price,
    costPrice: product.cost_price || product.costPrice,
    categoryName: product.category_name || product.categoryName,
    
    // ✅ Stock
    currentStock: product.current_stock !== undefined ? product.current_stock : (product.currentStock || 0),
    stock: product.current_stock !== undefined ? product.current_stock : (product.currentStock || 0),
    
    // ✅ Seuils de stock
    minThreshold: product.min_threshold || product.minThreshold || product.stock?.minThreshold || 5,
    maxThreshold: product.max_threshold || product.maxThreshold || product.stock?.maxThreshold || 100,
    
    // ✅ Images avec correction d'URL
    image: fixImageUrl(product.image_url || product.imageUrl),
    imageUrl: fixImageUrl(product.image_url || product.imageUrl),
    
    // ✅ Statuts
    isActive: product.is_active !== undefined ? product.is_active : (product.isActive !== false),
    isAvailable: product.is_available !== undefined ? product.is_available : (product.isAvailable !== false),
    isLowStock: product.is_low_stock !== undefined ? product.is_low_stock : (product.isLowStock === true),
    
    // ✅ Métadonnées
    boutiqueId: product.boutique_id || product.boutiqueId,
    createdAt: product.created_at || product.createdAt,
    updatedAt: product.updated_at || product.updatedAt,
    
    // =====================================================
    // ✅ NOUVEAU : CHAMPS PROMOTIONS
    // =====================================================
    hasPromo: hasPromo,
    promoPrice: promoPrice,
    discountPercentage: discountPercentage,
    activePromotionId: product.active_promotion_id || product.activePromotionId || null,
    activePromotionName: product.active_promotion_name || product.activePromotionName || null,
    
    // ✅ Prix effectif (promo si disponible, sinon normal)
    effectivePrice: hasPromo && promoPrice ? promoPrice : product.price,
    
    // ✅ Économies si promo
    savings: hasPromo && promoPrice && product.price ? (product.price - promoPrice) : 0,
    
    // ✅ Calculs utiles
    profitMargin: product.price && product.costPrice ? 
      ((product.price - product.costPrice) / product.price * 100).toFixed(1) + '%' : 
      'N/A',
    stockStatus: (product.current_stock !== undefined ? product.current_stock : (product.currentStock || 0)) > 
                 (product.min_threshold || product.minThreshold || product.stock?.minThreshold || 5) ? 'good' : 
                 (product.current_stock !== undefined ? product.current_stock : (product.currentStock || 0)) > 0 ? 'low' : 'empty',
    stockStatusColor: (product.current_stock !== undefined ? product.current_stock : (product.currentStock || 0)) > 
                      (product.min_threshold || product.minThreshold || product.stock?.minThreshold || 5) ? 'success' : 
                      (product.current_stock !== undefined ? product.current_stock : (product.currentStock || 0)) > 0 ? 'warning' : 'danger',
    
    // Prix formatés
    formattedPrice: product.price?.toLocaleString('fr-FR', {
      style: 'decimal',
      minimumFractionDigits: 0
    }) + ' FCFA' || '0 FCFA',
    formattedCostPrice: product.costPrice?.toLocaleString('fr-FR', {
      style: 'decimal',
      minimumFractionDigits: 0
    }) + ' FCFA' || '0 FCFA',
    
    // ✅ NOUVEAU : Prix promo formaté
    formattedPromoPrice: promoPrice ? promoPrice.toLocaleString('fr-FR', {
      style: 'decimal',
      minimumFractionDigits: 0
    }) + ' FCFA' : null
  };
  
  // Log si promo active
  if (formatted.hasPromo) {
  }
  
  return formatted;
};

/**
 * ✅ Formatage des produits pour la vente (POS) avec PROMOTIONS
 */
const formatProductForSale = (product) => {
  const productType = product.product_type || product.productType || 'STOCKABLE';
  
  // ✅ NOUVEAU : Récupérer les infos de promotion
  const hasPromo = product.has_promo || product.hasPromo || false;
  const promoPrice = product.promo_price || product.promoPrice || null;
  const discountPercentage = product.discount_percentage || product.discountPercentage || null;
  
  const formatted = {
    id: product.id,
    name: product.product_name || product.name || 'Produit sans nom',
    price: parseFloat(product.price || 0),
    categoryName: product.category_name || product.categoryName || 'Non catégorisé',
    sku: product.product_sku || product.sku || '',
    image: fixImageUrl(product.image_url || product.imageUrl),
    imageUrl: fixImageUrl(product.image_url || product.imageUrl),
    
    // Type de produit
    productType: productType,
    isStockable: productType === 'STOCKABLE',
    isService: productType === 'SERVICE',
    
    // Stock uniquement pour les produits stockables
    currentStock: productType === 'SERVICE' 
      ? null 
      : (product.current_stock !== undefined ? product.current_stock : (product.currentStock || 0)),
    
    isActive: product.is_active !== undefined ? product.is_active : (product.isActive !== false),
    isAvailable: product.is_available !== undefined ? product.is_available : (product.isAvailable !== false),
    isLowStock: productType === 'SERVICE' ? false : (product.is_low_stock !== undefined ? product.is_low_stock : (product.isLowStock === true)),
    
    boutiqueId: product.boutique_id || product.boutiqueId,
    
    // =====================================================
    // ✅ NOUVEAU : CHAMPS PROMOTIONS POUR LE POS
    // =====================================================
    hasPromo: hasPromo,
    promoPrice: promoPrice ? parseFloat(promoPrice) : null,
    discountPercentage: discountPercentage,
    activePromotionId: product.active_promotion_id || product.activePromotionId || null,
    activePromotionName: product.active_promotion_name || product.activePromotionName || null,
    
    // ✅ Prix effectif à utiliser pour la vente
    effectivePrice: hasPromo && promoPrice 
      ? parseFloat(promoPrice) 
      : parseFloat(product.price || 0),
    
    // ✅ Économies
    savings: hasPromo && promoPrice 
      ? parseFloat(product.price || 0) - parseFloat(promoPrice)
      : 0
  };
  
  // Log si promo active
  if (formatted.hasPromo) {
  }
  
  return formatted;
};

/**
 * ✅ Gestion des erreurs
 */
const getErrorMessage = (error) => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'Erreur inconnue';
};

/**
 * ✅ Endpoints API
 */
const endpoints = {
  products: {
    list: '/manager/products',
    create: '/manager/products',
    get: (id) => `/manager/products/${id}`,
    update: (id) => `/manager/products/${id}`,
    delete: (id) => `/manager/products/${id}`,
    deactivate: (id) => `/manager/products/${id}/deactivate`,
    search: '/manager/products/search',
    uploadImage: (id) => `/manager/products/${id}/upload-image`
  },
  categories: {
    list: '/manager/categories',
    create: '/manager/categories'
  }
};

/**
 * ✅ SERVICE PRINCIPAL
 */
const productService = {
  
  /**
   * ✅ Récupération des produits avec images corrigées
   */
  getProducts: async (params = {}) => {
    try {
      
      const queryParams = new URLSearchParams();
      if (params.page !== undefined) queryParams.append('page', params.page);
      if (params.size !== undefined) queryParams.append('size', params.size);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortDirection) queryParams.append('sortDirection', params.sortDirection);
      if (params.search) queryParams.append('search', params.search);
      if (params.category) queryParams.append('category', params.category);
      if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);

      const url = `/employee/products${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

      const response = await apiCall.get(url);
      
      if (response.success && response.data) {
        
        // ✅ Formater tous les produits avec correction des images
        const formattedProducts = Array.isArray(response.data) 
          ? response.data.map(formatProduct).filter(Boolean)
          : response.data.content?.map(formatProduct).filter(Boolean) || [];
          
        
        return {
          ...response,
          data: Array.isArray(response.data) 
            ? formattedProducts
            : {
                ...response.data,
                content: formattedProducts
              }
        };
      }
      
      return response;
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des produits:', error);
      return {
        success: false,
        data: [],
        message: 'Erreur de connexion'
      };
    }
  },

  /**
   * ✅ Création d'un produit
   */
  createProduct: async (productData) => {
    try {
      
      // ✅ NOUVEAU : Validation et préparation des données selon le type
      const productType = productData.productType || 'STOCKABLE';
      
      const finalProductData = {
        name: productData.name?.trim(),
        description: productData.description?.trim() || null,
        price: parseFloat(productData.price) || 0,
        costPrice: parseFloat(productData.costPrice) || 0,
        categoryName: productData.categoryName?.trim(),
        sku: productData.sku?.trim() || null,
        barcode: productData.barcode?.trim() || null,
        imageUrl: productData.imageUrl || null,
        productType: productType, // ✅ NOUVEAU
        isActive: productData.isActive !== false,
        
        // ✅ NOUVEAU : Champs de stock uniquement pour les produits stockables
        ...(productType === 'STOCKABLE' && {
          initialStock: parseInt(productData.initialStock) || 0,
          minThreshold: parseInt(productData.minThreshold) || 5,
          maxThreshold: parseInt(productData.maxThreshold) || 50
        })
      };
      
      
      const response = await apiCall.post(endpoints.products.create, finalProductData);
      
      if (response.success) {
        return response;
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('❌ Erreur création produit:', error);
      return {
        success: false,
        message: getErrorMessage(error)
      };
    }
  },

   createCategory: async (categoryData) => {
    try {
      
      const response = await apiCall.post('/manager/categories', categoryData);
      
      if (response.success) {
        return response;
      }
      
      return {
        success: false,
        message: response.message || 'Erreur lors de la création'
      };
    } catch (error) {
      console.error('❌ Erreur lors de la création de la catégorie:', error);
      return {
        success: false,
        message: getErrorMessage(error)
      };
    }
  },

  updateCategory: async (categoryId, categoryData) => {
  try {
    const response = await apiCall.put(`/manager/categories/${categoryId}`, categoryData);
    return response;
  } catch (error) {
    console.error('❌ Erreur updateCategory:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la modification de la catégorie'
    };
  }
},

/**
 * ✅ NOUVEAU: Supprimer une catégorie
 * Utilise: DELETE /api/manager/categories/{id}
 */
deleteCategory: async (categoryId) => {
  try {
    const response = await apiCall.delete(`/manager/categories/${categoryId}`);
    return response;
  } catch (error) {
    console.error('❌ Erreur deleteCategory:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la suppression de la catégorie'
    };
  }
},

  // ✅ CORRECTION productService.js - Méthode updateProduct avec préservation de l'image

/**
 * ✅ Mettre à jour un produit avec préservation intelligente de l'image  
 */
updateProduct: async (id, productData) => {
    try {
      
      // ✅ NOUVEAU : Gestion du changement de type
      const productType = productData.productType || 'STOCKABLE';
      
      const updateData = {
        ...productData,
        productType: productType,
        
        // ✅ NOUVEAU : Nettoyer les champs de stock si c'est un service
        ...(productType === 'SERVICE' && {
          currentStock: null,
          minThreshold: null,
          maxThreshold: null
        })
      };
      
      const response = await apiCall.put(endpoints.products.update(id), updateData);
      
      if (response.success) {
        return response;
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('❌ Erreur mise à jour produit:', error);
      return {
        success: false,
        message: getErrorMessage(error)
      };
    }
  },

// ✅ SOLUTION ALTERNATIVE : Méthode spécifique pour mettre à jour seulement l'image
updateProductImage: async (productId, imageUrl) => {
  try {
    
    // Récupérer le produit complet
    const existingProduct = await productService.getProductById(productId);
    if (!existingProduct.success) {
      throw new Error('Produit introuvable');
    }

    // Mettre à jour seulement l'image
    const updateData = {
      ...existingProduct.data,
      imageUrl: imageUrl
    };

    return await productService.updateProduct(productId, updateData);
    
  } catch (error) {
    console.error('❌ Erreur mise à jour image:', error);
    return {
      success: false,
      message: 'Erreur lors de la mise à jour de l\'image'
    };
  }
},

  /**
   * ✅ Récupérer un produit par ID
   */
  getProductById: async (productId) => {
    try {
      
      const endpoints = [
        `/manager/products/${productId}`,
        `/employee/products/${productId}`,
        `/common/products/${productId}`
      ];
      
      for (const endpoint of endpoints) {
        try {
          const response = await apiCall.get(endpoint);
          if (response.success) {
            return {
              ...response,
              data: formatProduct(response.data)
            };
          }
        } catch (error) {
          continue;
        }
      }
      
      return {
        success: false,
        data: null,
        message: 'Produit non trouvé'
      };
    } catch (error) {
      console.error('❌ Erreur lors de la récupération du produit:', error);
      return {
        success: false,
        data: null,
        message: 'Erreur de connexion'
      };
    }
  },

  /**
   * ✅ Rechercher des produits
   */
   searchProducts: async (searchTerm, filters = {}) => {
    try {
      
      const params = new URLSearchParams();
      if (searchTerm) params.append('search', searchTerm);
      if (filters.category) params.append('category', filters.category);
      if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
      if (filters.productType) params.append('productType', filters.productType); // ✅ NOUVEAU
      
      const response = await apiCall.get(`${endpoints.products.search}?${params.toString()}`);
      
      if (response.success) {
        const formattedProducts = response.data.map(formatProductForSale);
        
        return {
          success: true,
          data: formattedProducts
        };
      }
      
      return { success: false, data: [] };
      
    } catch (error) {
      console.error('❌ Erreur recherche:', error);
      return { success: false, data: [], message: getErrorMessage(error) };
    }
  },

  // ✅ NOUVEAU : Méthodes utilitaires
  isStockableProduct: (product) => {
    return (product.productType || product.product_type || 'STOCKABLE') === 'STOCKABLE';
  },

  getProductTypes: () => PRODUCT_TYPES,


  /**
   * ✅ Gestion des catégories
   */
  getCategories: async () => {
    try {
      
      const endpoints = [
        '/manager/categories',
        '/employee/categories',
        '/common/categories'
      ];
      
      for (const endpoint of endpoints) {
        try {
          const response = await apiCall.get(endpoint);
          if (response.success) {
            return response;
          }
        } catch (error) {
          continue;
        }
      }
      
      return {
        success: false,
        data: [],
        message: 'Impossible de récupérer les catégories'
      };
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des catégories:', error);
      return {
        success: false,
        data: [],
        message: 'Erreur de connexion'
      };
    }
  },

  createCategory: async (categoryData) => {
    try {
      
      const response = await apiCall.post('/manager/categories', categoryData);
      
      if (response.success) {
        return response;
      }
      
      return {
        success: false,
        message: response.message || 'Erreur lors de la création'
      };
    } catch (error) {
      console.error('❌ Erreur lors de la création de la catégorie:', error);
      return {
        success: false,
        message: getErrorMessage(error)
      };
    }
  },

  /**
   * ✅ Upload d'image pour un produit
   */
  uploadProductImage: async (productId, imageFile) => {
    try {
      
      // Validation côté client
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
      if (!validTypes.includes(imageFile.type)) {
        return {
          success: false,
          message: 'Type de fichier non supporté. Utilisez JPG, PNG ou WebP'
        };
      }
      
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (imageFile.size > maxSize) {
        return {
          success: false,
          message: 'La taille du fichier ne doit pas dépasser 5MB'
        };
      }
      
      // Créer FormData
      const formData = new FormData();
      formData.append('image', imageFile);
      
      
      // Appel API
      const response = await apiCall.upload(
        `/manager/products/${productId}/upload-image`,
        formData
      );
      
      
      if (response.success) {
        return {
          success: true,
          data: response.data, // URL de l'image
          message: 'Image uploadée avec succès'
        };
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('❌ Erreur upload image:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Erreur lors de l\'upload'
      };
    }
  },

  /**
   * ✅ Test d'upload simple
   */
  testUpload: async (file) => {
    try {
      
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await apiCall.upload('/manager/test-upload', formData);
      
      return response;
      
    } catch (error) {
      console.error('❌ Erreur test upload:', error);
      return {
        success: false,
        message: 'Erreur lors du test d\'upload'
      };
    }
  },

  /**
   * ✅ Désactiver un produit
   */
  deactivateProduct: async (productId) => {
    try {
      
      const response = await apiCall.patch(endpoints.products.deactivate(productId));
      
      if (response.success) {
        return response;
      }
      
      return {
        success: false,
        message: response.message || 'Erreur lors de la désactivation'
      };
    } catch (error) {
      console.error('❌ Erreur lors de la désactivation du produit:', error);
      return {
        success: false,
        message: getErrorMessage(error)
      };
    }
  },

  /**
   * ✅ Supprimer un produit
   */
  deleteProduct: async (productId) => {
    try {
      
      const response = await apiCall.delete(endpoints.products.delete(productId));
      
      if (response.success) {
        return response;
      }
      
      return {
        success: false,
        message: response.message || 'Erreur lors de la suppression'
      };
    } catch (error) {
      console.error('❌ Erreur lors de la suppression du produit:', error);
      return {
        success: false,
        message: getErrorMessage(error)
      };
    }
  },

  /**
 * ✅ Import multiple de produits depuis un fichier
 */
importProducts: async (file) => {
  try {

    // Validation du fichier
    const validTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'text/csv'
    ];

    if (!validTypes.includes(file.type)) {
      return {
        success: false,
        message: 'Format de fichier invalide. Utilisez .xlsx, .xls ou .csv'
      };
    }

    if (file.size > 5 * 1024 * 1024) {
      return {
        success: false,
        message: 'Le fichier est trop volumineux (max 5MB)'
      };
    }

    // Préparation du FormData
    const formData = new FormData();
    formData.append('file', file);


    // Appel API avec timeout étendu
    const response = await apiCall.upload(
    '/manager/products/import',  // URL directe
    formData,
  { timeout: 60000 }
  );

    if (response.success) {
      return {
        success: true,
        data: response.data,
        message: 'Import terminé avec succès'
      };
    }

    return {
      success: false,
      message: response.message || 'Erreur lors de l\'import'
    };

  } catch (error) {
    console.error('❌ Erreur lors de l\'import:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur de connexion lors de l\'import'
    };
  }
},

/**
 * ✅ Télécharger les informations du modèle d'import
 */
getImportTemplateInfo: async () => {
  try {

  const response = await apiCall.get('/manager/products/import/template');

    if (response.success) {
      return response;
    }

    return {
      success: false,
      message: response.message || 'Erreur lors de la récupération du modèle'
    };

  } catch (error) {
    console.error('❌ Erreur récupération modèle:', error);
    return {
      success: false,
      message: 'Erreur de connexion'
    };
  }
},

  /**
   * ✅ Récupérer les produits avec leur stock
   */
  getProductsWithStock: async (params = {}) => {
    try {
      
      const response = await productService.getProducts(params);
      
      if (response.success) {
        // Enrichir les informations de stock
        const enrichedProducts = response.data.map(product => ({
          ...product,
          currentStock: product.currentStock || product.stock || 0,
          isLowStock: (product.currentStock || product.stock || 0) <= (product.minThreshold || 5),
          isOutOfStock: (product.currentStock || product.stock || 0) === 0
        }));
        
        return {
          ...response,
          data: enrichedProducts
        };
      }
      
      return response;
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des produits avec stock:', error);
      return {
        success: false,
        data: [],
        message: 'Erreur de connexion'
      };
    }
  },

  /**
   * ✅ Valider les données d'un produit
   */
  validateProductData: (productData) => {
    const errors = [];
    
    if (!productData.name || productData.name.trim().length < 2) {
      errors.push('Le nom du produit est requis (min 2 caractères)');
    }
    
    if (!productData.price || productData.price <= 0) {
      errors.push('Le prix doit être supérieur à 0');
    }
    
    if (!productData.category_name || productData.category_name.trim().length < 2) {
      errors.push('La catégorie est requise');
    }
    
    if (productData.costPrice && productData.costPrice < 0) {
      errors.push('Le prix de revient ne peut pas être négatif');
    }
    
    if (productData.stock && productData.stock < 0) {
      errors.push('Le stock ne peut pas être négatif');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  },

  // ✅ Export des fonctions de formatage
  formatProduct,
  formatProductForSale,
  fixImageUrl,
  exportProducts
};

export default productService;
export { formatProduct, formatProductForSale, fixImageUrl,   exportProducts };